import { defineStore } from 'pinia';
import { ref } from 'vue';
import { WishlistCookieService } from '@/services/storage/wishlistCookieService';

export const useWishlistStore = defineStore('wishlist', () => {
  const productCodes = ref<Set<string>>(new Set());

  const has = (productCode: string): boolean => {
    return productCodes.value.has(productCode);
  };

  const loadFromCookie = (): void => {
    productCodes.value = new Set(WishlistCookieService.read());
  };

  const toggle = (productCode: string): void => {
    if (productCodes.value.has(productCode)) {
      productCodes.value.delete(productCode);
    } else {
      productCodes.value.add(productCode);
    }
    WishlistCookieService.write(Array.from(productCodes.value));
  };

  return {
    productCodes,
    has,
    toggle,
    loadFromCookie,
  };
});
